
























































































import { IQTablePagination } from '@/quasar-types'
import { IArticle, updateSortedEANs } from '@/store/article'
import { hasPermission } from '@laura-wert/vue-permission-management'
import { QBtn, QChip, QIcon, QInput, QSelect, QSpace, QTable, QTd, QTr } from 'quasar'
import { addColumnDefaults, IColumns } from '@ultraware/vue-helpers'
import TableStorageMixin from 'src/plugins/mixins/TableStorageMixin'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
import { EPermission } from '../laura-types'

@Component({
  components: {
    QBtn,
    QChip,
    QInput,
    QIcon,
    QTable,
    QTd,
    QTr,
    QSelect,
    QSpace,
  },
})
export default class ArticleTable extends Mixins(TableStorageMixin) {
  @Prop({ required: true, type: Array }) public articles!: IArticle[]
  @Mutation(updateSortedEANs) public updateSortedEans!: (_: IArticle[]) => void

  public namespace = 'articleTable'
  public filter = ''
  public visibleColumns: string[] = [
    'Publisher',
    'ProductId',
    'Title',
    'Authors',
    'Medium',
    'IntendedEndUserRole',
    'ProductState',
  ]

  public pagination: IQTablePagination = {
    sortBy: 'ProductId',
    descending: true,
    rowsPerPage: 10,
    page: 1,
  }

  public mounted(): void {
    if (hasPermission('u', EPermission.LIKA_ARTICLE) &&
      !this.visibleColumns.includes('editDelete')) this.visibleColumns.push('editDelete')
  }

  public handleEditArticle(productId: string): void {
    const oldSelection = this.pagination.rowsPerPage
    // Reset rowsPerPage to all, to make sure the amount, sorting and filtering of articles is
    // the same on both edit article page (previous and next buttons) as the current selection on articleoverviewtable
    this.pagination.rowsPerPage = 0
    // @ts-ignore
    this.updateSortedEans(this.$refs.articleTable.computedData.rows)

    this.pagination.rowsPerPage = oldSelection

    this.$router.push({ name: 'editArticle', params: { EAN: productId } })
  }

  public columns: IColumns[] = addColumnDefaults([
    {
      label: 'Uitgever',
      name: 'Publisher',
      field: 'Publisher',
    },
    {
      label: 'EAN/ProductID',
      field: 'ProductId',
      name: 'ProductId',
    },
    {
      label: 'Titel',
      field: 'Title',
      name: 'Title',
    },
    {
      label: 'Auteurs',
      field: 'Authors',
      name: 'Authors',
      sortable: false,
    },
    {
      label: 'Medium',
      field: 'Medium',
      name: 'Medium',
    },
    {
      label: 'Eindgebruiker',
      field: 'IntendedEndUserRole',
      name: 'IntendedEndUserRole',
    },
    {
      label: 'Product life cycle',
      field: 'ProductState',
      name: 'ProductState',
    },
    {
      label: 'Beheer',
      field: 'editDelete',
      name: 'editDelete',
      sortable: false,
    },
  ])
}
